import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useAuth } from '@/app/auth';
import { ProfileSessionProvider, type ProfileSession } from '@/modules/profile/route';

// O módulo não importa `src/app`: a sessão Cognito entra pela porta `ProfileSession` (SPEC do módulo).
export const Route = createFileRoute('/_app/meu-perfil')({ component: ProfileSessionRoute });

function ProfileSessionRoute() {
  const { user, session } = useAuth();
  const value: ProfileSession = {
    username: user?.username,
    changePassword: async (oldPassword, newPassword) => {
      const state = await session.changePassword(oldPassword, newPassword);
      return state.status === 'signedIn' && !state.error ? { ok: true } : { ok: false, message: state.error ?? '' };
    },
  };
  return (
    <ProfileSessionProvider value={value}>
      <Outlet />
    </ProfileSessionProvider>
  );
}
